module.exports = __webpack_public_path__ + "img/uv.3e151c36.jpg";